<template>
    <div>
        <van-popup v-model="contShow" round position="bottom" :style="{ height: '24rem',background:'#f7f7f7' }">
            <div class="agreement_box">
                <van-tabs color="#27282D" @click="onClick" v-model="active">
                    <van-tab title="新纪录榜">
                        <div class="box">
                            <div class="statistical">
                                <div class="statistical_con">
                                    <div class="statistical_shu">
                                        <div class="statistical_shu_list" v-for="(item,index) in statisticalData" :key="item.num">
                                            <div :class="'statistical_shu_name statistical_shu_'+(index+1)">{{item.ratio}}</div>
                                            <div class="statistical_shu_type">{{item.name}}</div>
                                            <div class="statistical_shu_num">{{item.number}}</div>
                                        </div>
                                    </div>
                                    <div class="statistical_xian">
                                        <template v-for="(item,index) in statisticalData">
                                            <div :key="item.num" :class="'statistical_xian_list statistical_xian_list_'+(index+1)" :style="'width:'+(Number((item.number/zongshu)*100).toFixed(2))+'%'"></div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <div class="cp_box">
                                <div class="cp_con">
                                    <div class="outer-container">
                                        <div class="inner-container">
                                            <div class="content">
                                                <template v-if="newRecordData.length==0">
                                                    <div class="none">
                                                        <img src="../../../assets/img/none.png" alt=""/>
                                                        <p>暂无数据</p>
                                                    </div>
                                                </template>
                                                <template v-if="newRecordData.length>0">
                                                    <div v-for="(item,index) in newRecordData" :key="item.lot" :title="item" style="width:100%;background:#fff;padding:0rem 0.6rem">
                                                        <div class="cp_list" v-if="index<20">
                                                            <div class="cp_list_tu" @click="ppxq(item)">
                                                                <van-image fit="contain" :src="item.cover_pic"/>
                                                            </div>
                                                            <div class="cp_list_con">
                                                                <div class="cp_list_name van-multi-ellipsis--l2" @click="ppxq(item)">
                                                                    <span class="s2 sss">新纪录</span>
                                                                    <span class="sss0">已结拍</span>
                                                                    {{item.title}}
                                                                </div>
                                                                <div class="cp_list_conBox">
                                                                    <template v-for="(items) in item.extra_info">
                                                                        <div class="cp_list_nr cp_list_nr1" :key="items.type" v-if="items.type=='hammer_price'">
                                                                            {{items.label}}
                                                                            <!-- <span class="ss s11">{{items.small_text}}</span>
                                                                            <span class="ss s12">{{items.text}}</span> -->
                                                                            <span class="ss s11"  @click="dlu">{{items.small_text}}</span>
                                                                            <span  @click="dlu" class="ss s12" v-if="isVipMember">{{items.text}}</span>
                                                                            <span  @click="dlu" class="ss s12" v-else>{{items.nonMemberText}}</span>
                                                                            <!-- <span style="color:red;" v-if="liveData.isLogin==0" @click="dlu">请登录后查看</span> -->
                                                                        </div>
                                                                        
                                                                    </template>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </van-tab>
                    <van-tab title="溢价榜">
                        <div class="box">
                            <div class="statistical">
                                <div class="statistical_con">
                                    <div class="statistical_shu">
                                        <div class="statistical_shu_list" v-for="(item,index) in statisticalData" :key="item.num">
                                            <div :class="'statistical_shu_name statistical_shu_'+(index+1)">{{item.ratio}}</div>
                                            <div class="statistical_shu_type">{{item.name}}</div>
                                            <div class="statistical_shu_num">{{item.number}}</div>
                                        </div>
                                    </div>
                                    <div class="statistical_xian">
                                        <template v-for="(item,index) in statisticalData">
                                            <div :key="item.num" :class="'statistical_xian_list statistical_xian_list_'+(index+1)" :style="'width:'+(Number((item.number/zongshu)*100).toFixed(2))+'%'"></div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <div class="cp_box">
                                <div class="cp_con">
                                    <div class="outer-container">
                                        <div class="inner-container">
                                            <div class="content">
                                                <template v-if="premiumData.length==0">
                                                    <div class="none">
                                                        <img src="../../../assets/img/none.png" alt=""/>
                                                        <p>暂无数据</p>
                                                    </div>
                                                </template>
                                                <template v-if="premiumData.length>0">
                                                    <div v-for="(item,index) in premiumData" :key="item.lot" :title="item" style="width:100%;background:#fff;padding:0rem 0.6rem">
                                                        <div class="cp_list" v-if="index<20">
                                                            <div class="cp_list_tu" @click="ppxq(item)">
                                                                <div class="cp_list_tu_bq cp_list_tu_bq1" v-if="index<9">0{{index+1}}</div>
                                                                <div class="cp_list_tu_bq cp_list_tu_bq1" v-if="index==9">{{index+1}}</div>
                                                                <van-image fit="contain" :src="item.cover_pic"/>
                                                            </div>
                                                            <div class="cp_list_con">
                                                                <div class="cp_list_name van-multi-ellipsis--l2" @click="ppxq(item)" style="text-indent:0rem;">{{item.title}}</div>
                                                                <div class="cp_list_conBox">
                                                                    <div class="cp_list_nr cp_list_nr3">
                                                                        <template v-for="(items) in item.extra_info">
                                                                            <div :key="items.type" v-if="items.type=='premium'">{{items.label}}
                                                                                <!-- <span class="ss s11">{{items.small_text}}</span><span class="ss s12">{{items.text}}</span> -->
                                                                                <span class="ss s11"  @click="dlu">{{items.small_text}}</span><span class="ss s12" @click="dlu">{{items.text}}</span>
                                                                                <!-- <span style="color:red;" v-if="liveData.isLogin==0" @click="dlu">请登录后查看</span> -->
                                                                            </div>
                                                                        </template>
                                                                    </div>
                                                                    <div class="cp_list_nr cp_list_nr1">
                                                                        <template v-for="(items) in item.extra_info">
                                                                            <!--  <div :key="items.type" v-if="items.type=='price'">{{items.label}}
                                                                               <span class="ss s11">{{items.small_text}}</span><span class="ss s12">{{items.text}}</span>
                                                                                <span class="ss s11" v-if="liveData.isLogin==1">{{items.small_text}}</span><span class="ss s12" v-if="liveData.isLogin==1">{{items.text}}</span>
                                                                                <span style="color:red;" v-if="liveData.isLogin==0" @click="dlu">请登录后查看</span>
                                                                            </div> -->
                                                                            <div :key="items.type" v-if="items.type=='hammer_price'">{{items.label}}
                                                                                <!-- <span class="ss s11">{{items.small_text}}</span><span class="ss s12">{{items.text}}</span> -->
                                                                                <span class="ss s11"   @click="dlu">{{items.small_text}}</span>
                                                                                <span  @click="dlu" class="ss s12" v-if="isVipMember">{{items.text}}</span>
                                                                                <span  @click="dlu" class="ss s12" v-else>{{items.nonMemberText}}</span>
                                                                            </div>
                                                                        </template>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </van-tab>
                </van-tabs>
            </div>
        </van-popup>
    </div>
</template>

<script>
export default {
    props:["liveData","announcementShow","statisticalData","newRecordData","premiumData","zongshu","isVipMember"],
    data() {
        return {
            contShow: this.announcementShow, //显示
            active:0,
        };
    },
    methods: {
        announcementFun(show){
            this.contShow=show;
        },
        // 新纪录榜和溢价榜
        onClick(name, title) {
            if(title=="新纪录榜"){
                this.active=0;
            }else if(title=="溢价榜"){
                this.active=1;
            }
        },
        // 跳转拍品详情
        ppxq(data) {
            if(this.$route.query.from=='2'){//有水印
                //this.$router.push({path: '/auction',query:{ liveid:Number(this.$route.query.id),art_id:data.art_id,from:'2'}});
                this.$router.push(`auction/${this.$route.query.id}/${data.art_id}/${this.$route.query.special_id}`+'?from=2&btnShow=1')
            }else{//无水印
                //this.$router.push({path: '/auction',query:{ liveid:Number(this.$route.query.id),art_id:data.art_id}});
                this.$router.push(`auction/${this.$route.query.id}/${data.art_id}/${this.$route.query.special_id}`+'?btnShow=1')
            }
        },
        //未登录
        dlu(){
            if(this.liveData.isLogin==0){
                window.location.href = '//passport.artron.net/login?appId=1&redirect='+encodeURIComponent(window.location.href)
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.agreement_box{
    width:100%;
    height:auto;
}
.box{
    width:100%;
    max-height:20.9rem;
    overflow-x:hidden;
    overflow-y:auto;
}
.statistical{
    width:100%;
    height:auto;
    background:#F7F7F7;
    padding:0.4rem;
}
.statistical_con{
    width:100%;
    height:auto;
    background:#fff;
    padding:0.8rem;
    border-radius:0.3rem;
}
.statistical_shu{
    width:100%;
    height:auto;
    overflow:hidden;
}
.statistical_shu_list{
    width:25%;
    height:auto;
    float:left;
    padding:0px 0.5rem;
}
.statistical_shu_name{
    width:100%;
    line-height:1.6rem;
    font-size:1rem;
    font-weight:bold;
}
.statistical_shu_type{
    width:100%;
    line-height:1rem;
    font-size:0.5rem;
    color:#CCCCCC;
}
.statistical_shu_num{
    width:100%;
    line-height:1.6rem;
    font-size:0.7rem;
    color:#666666;
}
.statistical_shu_1{
    color:#FF5D4F;
}
.statistical_shu_2{
    color:#3D7FFF;
}
.statistical_shu_3{
    color:#18BD6F;
}
.statistical_shu_4{
    color:#BDC4CF;
}
.statistical_xian{
    width:100%;
    height:0.3rem;
    overflow:hidden;
    border-radius:0.2rem;
    margin-top:0.4rem;
}
.statistical_xian_list{
    height:100%;
    float:left;
}
.statistical_xian_list_1{
    background:#FF5D4F;
}
.statistical_xian_list_2{
    background:#3D7FFF;
}
.statistical_xian_list_3{
    background:#18BD6F;
}
.statistical_xian_list_4{
    background:#BDC4CF;
}

.cp_box{
    width:100%;
}
.cp_con{
    width:100%;
    border-top:1px solid #F7F7F7;
}
.cp_list{
    width:100%;
    height:auto;
    overflow:hidden;
    padding:0.4rem 0rem;
}
.cp_list_tu{
    width:22%;
    height:5rem;
    float:left;
    border-radius:0.25rem;
    overflow:hidden;
    position:relative;
    background:#eee;
}
.cp_list_tu img{
    width:100%;
    height:100%;
}
.cp_list_tu_bq{
    width:1.2rem;
    height:1.2rem;
    position:absolute;
    top:0px;
    left:0px;
    z-index:9999;
    text-align:center;
    line-height:1rem;
    font-size:0.7rem;
    color:#fff;
    border-radius:0px 0px 80% 0px;
}
.cp_list_tu_bq1{
    background:#18BD6F;
}
.cp_list_con {
    width: 75%;
    height: 5rem;
    float: right;
    position:relative;
}
.cp_list_conBox {
    width: 100%;
    height: auto;
    position:absolute;
    bottom:0px;
    left:0px;
}
.cp_list_name{
    width:100%;
    line-height:1.1rem;
    font-size:0.8rem;
    color:#27282D;
    margin:0.2rem 0rem;
    overflow:hidden;
    position:relative;
}
.cp_list_name .sss0 {
    display: inline-block;
    padding: 0rem 0.2rem;
    font-size: 0.5rem;
    border-radius: 0.1rem;
    color: #fff;
    line-height: 0.8rem;
}
.cp_list_name .sss {
    display:inline-block;
    padding:0rem 0.2rem;
    font-size:0.5rem;
    border-radius: 0.1rem;
    color:#fff;
    line-height: 0.8rem;
    position:absolute;
    top:0.15rem;
    left:0rem;
}
.cp_list_name .s1{
    background:#E35458;
}
.cp_list_name .s2{
    background:#18BD6F;
}
.cp_list_name .s3{
    background:#656565;
}
.cp_list_nr{
    width:100%;
    line-height:1rem;
    font-size:0.7rem;
    color:#969696;
    margin:0.1rem 0rem;
}
.cp_list_nr .s11{
    font-size:0.5rem;
}
.cp_list_nr .ss{
    font-weight:bold;
}
.cp_list_nr .s11{
    margin:0px 0.2rem 0px 0.3rem;
}
.cp_list_nr1 .ss{
    color:#FF3B30;
}
.cp_list_nr2 .ss{
    color:#969696;
}
.cp_list_nr3 .ss{
    color:#27282D;
}
.cp_list_nr4 .ss{
    color:#18BD6F;
}

/deep/ .van-empty{
    padding:1rem 0rem;
}
.van-image{
    width:100%;
    height:100%;
}
/deep/ .van-tab{font-size:0.8rem;}
/deep/ .van-tabs--line .van-tabs__wrap{height:3rem;}
</style>